import { Stack, Typography, Link } from '@krakentech/coral';

import { Alert } from '@/components';
import { INTERNAL_PATHS } from '@/utils/urls';

// This is for if the email is already registered without a password
const EmailAlreadyRegisteredNoPasswordAlert = ({
  email,
}: {
  email: string;
}) => (
  <Alert severity="warning">
    <Stack direction="vertical">
      <Typography>
        This account is already registered under {email} but it looks like a
        password has not been created yet.
      </Typography>
      <Link href={INTERNAL_PATHS.FORGOTTEN_PASSWORD.path} key="Reset password">
        <span>Send link to create a new password</span>
      </Link>
    </Stack>
  </Alert>
);

export default EmailAlreadyRegisteredNoPasswordAlert;
